import React, { useMemo } from 'react';
import { Row, Col } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import MetaTable from '@dex/bubl-dash/src/lib/components/MetaTable/MetaTable';
import ActivityPanel from '@dex/bubl-dash/src/lib/components/SinglePanels/ActivityPanel';

const ReactionSingleView: React.FC<any> = (props: any) => {

    const { data } = props;

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <Col
                className={'main'}
            >

                <Panel
                    heading={"Reaction Details"}
                >

                    <MetaTable
                        data={data}
                        columnA={[
                            {
                                label: "Reaction",
                                key: "reaction",
                                format: "titleCase"
                            },
                            {
                                label: "Owner",
                                key: "owner",
                                format: "ModelLink",
                            },
                            {
                                label: "Parent",
                                key: "parentType"
                            },
                            {
                                label: "Parent Title",
                                key: "parent",
                                format: "ModelLink",
                            }
                        ]}
                        columnB={[

                        ]}
                        columnC={[

                        ]}
                    />

                </Panel>

            </Col>

            <Col className={'side'}>

                <ActivityPanel parent={data} />

            </Col>

        </Row>

    ), [data]);

}

export default ReactionSingleView;
